module.exports = __webpack_public_path__ + "img/p3_2.ab11f8e4.webp";